import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import phoneImage from '../../assets/images/phone.png';
import tabletImage from '../../assets/images/tablet.png';
import laptopImage from '../../assets/images/laptop.png';
import QualityControl from '../../../assets/images/client-images/quality-control.avif';
import RepairGuarantee from '../../../assets/images/client-images/repair-guarantee.avif';
import ProtectDevice from '../../../assets/images/client-images/Protect-Device.avif';
import RetailShop from '../../../assets/images/client-images/Retail-Shop.avif';
import smartphone from '../../assets/images/services/smartphone.png';
import battery from '../../assets/images/services/battery.png';
import camera from '../../assets/images/services/camera.png';
import smartHome from '../../assets/images/services/smart-home.png';
import softwareDevelopment from '../../assets/images/services/software-development.png';
import wireless from '../../assets/images/services/wireless.png';

const stats = [
  { number: '15+', label: 'UK Locations' },
  { number: '50K+', label: 'Happy Customers' },
  { number: '10+', label: 'Years Experience' },
  { number: '99%', label: 'Satisfaction Rate' },
];

const devices = [
  { image: phoneImage, label: 'Smartphone', type: 'phone' },
  { image: tabletImage, label: 'Tablet', type: 'tablet' },
  { image: laptopImage, label: 'Laptop', type: 'laptop' },
];

const services = [
  { icon: smartphone, title: 'Screen Replacement', desc: 'Premium quality screen repairs for all brands using genuine parts.' },
  { icon: battery, title: 'Battery Replacement', desc: 'Restore your device battery life with certified OEM batteries.' },
  { icon: camera, title: 'Camera Repair', desc: 'Front and rear camera repairs for crystal-clear photos every time.' },
  { icon: smartHome, title: 'Housing Replacement', desc: 'Full device housing replacements for a brand-new appearance.' },
  { icon: softwareDevelopment, title: 'Software Update', desc: 'iOS, Android and Windows software repairs and system updates.' },
  { icon: wireless, title: 'Network Unlocking', desc: 'Unlock your device to use with any carrier worldwide.' },
];

const features = [
  { image: QualityControl, title: 'Quality Control', desc: 'Every device quality-checked and refurbished to perfect condition, unlocked for any network.' },
  { image: RepairGuarantee, title: 'Repair Guarantee', desc: '1-year warranty against manufacturing or software faults on all our repairs.' },
  { image: ProtectDevice, title: 'Protect Your Device', desc: 'Premium protection cases and tempered glass available across all stores.' },
  { image: RetailShop, title: 'Retail Shop', desc: 'Wide range of accessories and protection for all device types. Prices from £10.' },
];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { delay, duration: 0.55 },
});

function SectionLabel({ children }) {
  return (
    <div style={{
      fontSize: '11px', letterSpacing: '4px', color: '#c61515',
      fontWeight: '800', marginBottom: '14px', textTransform: 'uppercase',
    }}>
      {children}
    </div>
  );
}

function SectionTitle({ children }) {
  return (
    <h2 style={{ color: 'white', fontSize: 'clamp(26px, 4vw, 36px)', fontWeight: '800', margin: '0 0 18px' }}>
      {children}
    </h2>
  );
}

function Divider() {
  return <div style={{ width: '50px', height: '3px', background: 'linear-gradient(90deg, #c61515, #780e0f)', margin: '0 auto' }} />;
}

function Glow({ top, right, bottom, left, size = '500px', opacity = 0.12 }) {
  return (
    <div style={{
      position: 'absolute', top, right, bottom, left,
      width: size, height: size, borderRadius: '50%', pointerEvents: 'none',
      background: `radial-gradient(circle, rgba(198,21,21,${opacity}) 0%, transparent 70%)`,
    }} />
  );
}

function HomePage() {
  return (
    <div style={{ background: '#080808' }}>

      {/* ── Hero ── */}
      <section style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #080808 0%, #0d0d0d 60%, #110404 100%)',
        display: 'flex', alignItems: 'center',
        position: 'relative', overflow: 'hidden', paddingTop: '78px',
      }}>
        <Glow top="-15%" right="-8%" size="600px" opacity={0.14} />
        <Glow bottom="-20%" left="-10%" size="450px" opacity={0.07} />

        {/* Subtle grid */}
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }} />

        <div style={{ padding: '5%', width: '100%', maxWidth: '1280px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '60px', flexWrap: 'wrap' }}>

            {/* Left — headline */}
            <div style={{ flex: '1', minWidth: '290px' }}>
              <motion.div
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
                style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}
              >
                <span style={{ display: 'inline-block', width: '36px', height: '2px', background: '#c61515' }} />
                <span style={{ fontSize: '11px', letterSpacing: '3.5px', color: '#c61515', fontWeight: '800' }}>
                  UK'S TRUSTED REPAIR SPECIALISTS
                </span>
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.18, duration: 0.7 }}
                style={{ fontSize: 'clamp(38px, 5.5vw, 68px)', fontWeight: '900', color: 'white', lineHeight: '1.06', margin: '0 0 24px' }}
              >
                Your Device.
                <br />
                <span style={{
                  background: 'linear-gradient(135deg, #dd4d4e 0%, #c61515 50%, #780e0f 100%)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
                }}>
                  Our Expertise.
                </span>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.36, duration: 0.6 }}
                style={{ color: '#777', fontSize: '15px', lineHeight: '1.85', maxWidth: '500px', margin: '0 0 40px' }}
              >
                Phone Clinic 4U — UK's leading mobile phone repair specialists.
                Professional repairs with genuine parts, backed by our industry-leading warranty.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.52, duration: 0.6 }}
                style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}
              >
                <Link to="/services" style={{ textDecoration: 'none' }}>
                  <motion.button
                    whileHover={{ scale: 1.06, boxShadow: '0 0 32px rgba(198,21,21,0.55)' }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      background: 'linear-gradient(135deg, #c61515, #780e0f)',
                      color: 'white', border: 'none', padding: '13px 30px',
                      borderRadius: '9px', fontSize: '12px', letterSpacing: '1.8px',
                      fontWeight: '800', cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                    }}
                  >
                    BOOK A REPAIR
                  </motion.button>
                </Link>
                <Link to="/about-us" style={{ textDecoration: 'none' }}>
                  <motion.button
                    whileHover={{ scale: 1.05, borderColor: '#c61515', color: '#c61515' }}
                    transition={{ duration: 0.25 }}
                    style={{
                      background: 'transparent', color: '#aaa',
                      border: '1px solid rgba(255,255,255,0.18)',
                      padding: '13px 30px', borderRadius: '9px',
                      fontSize: '12px', letterSpacing: '1.8px', fontWeight: '800',
                      cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                    }}
                  >
                    LEARN MORE
                  </motion.button>
                </Link>
              </motion.div>
            </div>

            {/* Right — floating phone */}
            <motion.div
              initial={{ opacity: 0, x: 60 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3, duration: 0.9 }}
              style={{ flex: '1', minWidth: '260px', display: 'flex', justifyContent: 'center', position: 'relative' }}
            >
              <motion.div
                animate={{ rotate: 360 }} transition={{ duration: 22, repeat: Infinity, ease: 'linear' }}
                style={{
                  position: 'absolute', top: '50%', left: '50%',
                  transform: 'translate(-50%,-50%)', width: '340px', height: '340px',
                  borderRadius: '50%', border: '1px solid rgba(198,21,21,0.14)',
                }}
              />
              <motion.div
                animate={{ rotate: -360 }} transition={{ duration: 34, repeat: Infinity, ease: 'linear' }}
                style={{
                  position: 'absolute', top: '50%', left: '50%',
                  transform: 'translate(-50%,-50%)', width: '430px', height: '430px',
                  borderRadius: '50%', border: '1px dashed rgba(198,21,21,0.06)',
                }}
              />
              <motion.img
                src={phoneImage} alt="Smartphone repair"
                animate={{ y: [-10, 10, -10] }} transition={{ duration: 4.5, repeat: Infinity, ease: 'easeInOut' }}
                style={{
                  width: '220px',
                  filter: 'drop-shadow(0 24px 64px rgba(198,21,21,0.32))',
                  position: 'relative', zIndex: 1,
                }}
              />
            </motion.div>
          </div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          animate={{ y: [0, 10, 0] }} transition={{ duration: 2.2, repeat: Infinity }}
          style={{
            position: 'absolute', bottom: '28px', left: '50%', transform: 'translateX(-50%)',
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px',
          }}
        >
          <span style={{ color: '#333', fontSize: '10px', letterSpacing: '2.5px' }}>SCROLL</span>
          <div style={{ width: '1px', height: '38px', background: 'linear-gradient(to bottom, rgba(198,21,21,0.6), transparent)' }} />
        </motion.div>
      </section>

      {/* ── Stats Strip ── */}
      <section style={{ background: 'linear-gradient(135deg, #c61515 0%, #780e0f 100%)', padding: '42px 5%' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
          gap: '20px', maxWidth: '1200px', margin: '0 auto',
        }}>
          {stats.map((s, i) => (
            <motion.div
              key={s.label} {...fadeUp(i * 0.1)}
              style={{ textAlign: 'center' }}
            >
              <div style={{ color: 'white', fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: '900' }}>{s.number}</div>
              <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: '12px', letterSpacing: '1.2px', marginTop: '4px' }}>{s.label}</div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ── What We Repair ── */}
      <section style={{ padding: '100px 5%', background: '#080808' }}>
        <motion.div {...fadeUp()} style={{ textAlign: 'center', marginBottom: '60px' }}>
          <SectionLabel>REPAIRS FOR EVERY DEVICE</SectionLabel>
          <SectionTitle>What We <span style={{ color: '#c61515' }}>Repair</span></SectionTitle>
          <Divider />
        </motion.div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '22px', maxWidth: '980px', margin: '0 auto',
        }}>
          {devices.map((d, i) => (
            <motion.div
              key={d.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0, transition: { delay: i * 0.14, duration: 0.6 } }}
              viewport={{ once: true }}
              whileHover={{ y: -12, borderColor: 'rgba(198,21,21,0.45)' }}
              transition={{ duration: 0.3 }}
              style={{
                background: 'rgba(255,255,255,0.028)',
                border: '1px solid rgba(255,255,255,0.07)',
                borderRadius: '20px', padding: '44px 28px', textAlign: 'center',
                position: 'relative', overflow: 'hidden',
              }}
            >
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                background: 'linear-gradient(135deg, rgba(198,21,21,0.06) 0%, transparent 60%)',
                borderRadius: '20px', pointerEvents: 'none',
              }} />
              <img
                src={d.image} alt={d.label}
                style={{
                  width: '120px', height: '120px', objectFit: 'contain', marginBottom: '22px',
                  filter: 'drop-shadow(0 10px 28px rgba(198,21,21,0.28))',
                }}
              />
              <h4 style={{ color: 'white', fontSize: '20px', fontWeight: '800', margin: '0 0 18px' }}>
                {d.label}
              </h4>
              <Link to={`/repair/${d.type}`} style={{ textDecoration: 'none' }}>
                <motion.button
                  whileHover={{ scale: 1.06, boxShadow: '0 0 22px rgba(198,21,21,0.45)' }}
                  whileTap={{ scale: 0.94 }}
                  style={{
                    background: 'linear-gradient(135deg, #c61515, #780e0f)',
                    color: 'white', border: 'none', padding: '10px 26px',
                    borderRadius: '8px', fontSize: '12px', letterSpacing: '1.5px',
                    fontWeight: '800', cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                  }}
                >
                  BOOK NOW
                </motion.button>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ── Services ── */}
      <section style={{ padding: '100px 5%', background: 'linear-gradient(180deg, #080808 0%, #0c0404 100%)' }}>
        <motion.div {...fadeUp()} style={{ textAlign: 'center', marginBottom: '60px' }}>
          <SectionLabel>WHAT WE OFFER</SectionLabel>
          <SectionTitle>Our <span style={{ color: '#c61515' }}>Services</span></SectionTitle>
          <Divider />
        </motion.div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '18px', maxWidth: '1200px', margin: '0 auto',
        }}>
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.5 } }}
              viewport={{ once: true }}
              whileHover={{ y: -6, borderColor: 'rgba(198,21,21,0.38)' }}
              transition={{ duration: 0.25 }}
              style={{
                background: 'rgba(255,255,255,0.025)',
                border: '1px solid rgba(255,255,255,0.06)',
                borderRadius: '14px', padding: '24px',
                display: 'flex', gap: '16px', alignItems: 'flex-start',
              }}
            >
              <div style={{
                width: '50px', height: '50px', flexShrink: 0,
                background: 'rgba(198,21,21,0.1)', border: '1px solid rgba(198,21,21,0.22)',
                borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <img src={s.icon} alt={s.title} style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
              </div>
              <div>
                <h4 style={{ color: 'white', fontSize: '15px', fontWeight: '800', margin: '0 0 7px' }}>
                  {s.title}
                </h4>
                <p style={{ color: '#666', fontSize: '13px', margin: 0, lineHeight: '1.65' }}>
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ── About Features ── */}
      <section style={{ padding: '100px 5%', background: '#080808' }}>
        <motion.div {...fadeUp()} style={{ textAlign: 'center', marginBottom: '60px' }}>
          <SectionLabel>ABOUT US</SectionLabel>
          <SectionTitle>Why <span style={{ color: '#c61515' }}>Phone Clinic 4U</span></SectionTitle>
          <p style={{ color: '#666', maxWidth: '580px', margin: '18px auto 0', fontSize: '14px', lineHeight: '1.8' }}>
            UK based, growing mobile phone sales and services company bringing the latest phones and quality repairs to customers across the country.
          </p>
        </motion.div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '22px', maxWidth: '1200px', margin: '0 auto',
        }}>
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.55 } }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              transition={{ duration: 0.3 }}
              style={{
                background: 'rgba(255,255,255,0.025)',
                border: '1px solid rgba(255,255,255,0.07)',
                borderRadius: '16px', overflow: 'hidden',
              }}
            >
              <div style={{ height: '190px', overflow: 'hidden', position: 'relative' }}>
                <img src={f.image} alt={f.title} style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.65)' }} />
                <div style={{
                  position: 'absolute', bottom: 0, left: 0, right: 0, height: '55%',
                  background: 'linear-gradient(to top, rgba(8,8,8,1), transparent)',
                }} />
              </div>
              <div style={{ padding: '22px' }}>
                <h4 style={{ color: 'white', fontSize: '17px', fontWeight: '800', margin: '0 0 9px' }}>{f.title}</h4>
                <p style={{ color: '#666', fontSize: '13px', margin: 0, lineHeight: '1.65' }}>{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section style={{
        padding: '90px 5%', textAlign: 'center',
        background: 'linear-gradient(135deg, #c61515 0%, #780e0f 100%)',
        position: 'relative', overflow: 'hidden',
      }}>
        <motion.div
          animate={{ rotate: 360 }} transition={{ duration: 70, repeat: Infinity, ease: 'linear' }}
          style={{
            position: 'absolute', top: '-40%', right: '-8%',
            width: '520px', height: '520px', borderRadius: '50%',
            border: '1px solid rgba(255,255,255,0.07)', pointerEvents: 'none',
          }}
        />
        <motion.div
          animate={{ rotate: -360 }} transition={{ duration: 50, repeat: Infinity, ease: 'linear' }}
          style={{
            position: 'absolute', bottom: '-50%', left: '-5%',
            width: '400px', height: '400px', borderRadius: '50%',
            border: '1px dashed rgba(255,255,255,0.05)', pointerEvents: 'none',
          }}
        />
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={{ position: 'relative', zIndex: 1 }}>
          <h2 style={{ color: 'white', fontSize: 'clamp(26px, 4vw, 38px)', fontWeight: '900', margin: '0 0 16px' }}>
            Ready to Fix Your Device?
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '15px', margin: '0 auto 36px', maxWidth: '480px', lineHeight: '1.75' }}>
            Book your repair online in minutes. Fast, professional, and backed by our warranty guarantee.
          </p>
          <Link to="/services" style={{ textDecoration: 'none' }}>
            <motion.button
              whileHover={{ scale: 1.06, background: 'white', color: '#c61515' }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
              style={{
                background: 'rgba(255,255,255,0.14)',
                color: 'white', border: '2px solid rgba(255,255,255,0.8)',
                padding: '14px 40px', borderRadius: '10px',
                fontSize: '12px', letterSpacing: '2px', fontWeight: '800',
                cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
              }}
            >
              BOOK YOUR REPAIR NOW
            </motion.button>
          </Link>
        </motion.div>
      </section>
    </div>
  );
}

export default HomePage;
